import { FieldsOrder } from "../Subjects/types";
import { AdjudicationPendingIssues, AdjudicationSolvedFinalDecision, AdjudicationSolvedIssues, AdjudicatorDecisionDecision, AdjudicatorDecisionTypeOfAttack } from "neurotec-megamatcherid-management-client-adjudicator";

export enum adjudicationSettings {
    LIVE_ADJUDICATION = "fv.management.adjudication.liveadjudication",
    FACE_LIVENESS_ENABLE = "fv.management.adjudication.face.liveness.enable",
    FACE_LIVENESS_RANGE = "fv.management.adjudication.face.liveness.threshold.range",
    FACE_AGE_ENABLE = "fv.management.adjudication.face.age.enable",
    FACE_AGE_THRESHOLD_LOWERBOUND = "fv.management.adjudication.face.age.threshold.lowerbound",
    FACE_AGE_THRESHOLD_UPPERBOUND = "fv.management.adjudication.face.age.threshold.upperbound",
    ADJUDICATOR_TOTAL_COUNT = "fv.management.adjudication.decision.requires.total",
    ADJUDICATOR_TOTAL_ACCEPTED = "fv.management.adjudication.decision.requires.accepted"
}

export enum AdjudicationPendingFieldOrderBy {
    FILTER_ADJUDICATION_PENDING_UUID = "FILTER_ADJUDICATION_PENDING_UUID",
    FILTER_ADJUDICATION_PENDING_OPERATION_UUID = "FILTER_ADJUDICATION_PENDING_OPERATION_UUID",
    FILTER_ADJUDICATION_PENDING_ISSUES = "FILTER_ADJUDICATION_PENDING_ISSUES",
    FILTER_ADJUDICATION_PENDING_DATE = "FILTER_ADJUDICATION_PENDING_DATE"
}

export interface IAdjudicationPendingFilter {
    fieldToOrderBy?: AdjudicationPendingFieldOrderBy
    fieldsOrder?: FieldsOrder,

    uuid?: string,
    operationUuid?: string,
    dateLowerBound?: number,
    dateUpperBound?: number,
    issues?: AdjudicationPendingIssues[]
}

export enum AdjudicatorDecisionFieldOrderBy {
    FILTER_ADJUDICATOR_DECISION_UUID = "FILTER_ADJUDICATOR_DECISION_UUID",
	FILTER_ADJUDICATOR_DECISION_DATE = "FILTER_ADJUDICATOR_DECISION_DATE",
	FILTER_ADJUDICATOR_DECISION_ADJUDICATION_UUID = "FILTER_ADJUDICATOR_DECISION_ADJUDICATION_UUID",
	FILTER_ADJUDICATOR_DECISION_ACCOUNT_UUID = "FILTER_ADJUDICATOR_DECISION_ACCOUNT_UUID",
	FILTER_ADJUDICATOR_DECISION_DECISION = "FILTER_ADJUDICATOR_DECISION_DECISION",
	FILTER_ADJUDICATOR_DECISION_TYPE_OF_ATTACK = "FILTER_ADJUDICATOR_DECISION_TYPE_OF_ATTACK",
}

export interface IAdjudicatorDecisionFilter {
    fieldToOrderBy?: AdjudicatorDecisionFieldOrderBy,
    fieldsOrder?: FieldsOrder,
    
    uuid?: string
    dateLowerBound?: number,
    dateUpperBound?: number,
    adjudicationUuid?: string,
    decision?: AdjudicatorDecisionDecision[],
    attack?: AdjudicatorDecisionTypeOfAttack[],
}

export enum AdjudicationSolvedFieldOrderBy {
    FILTER_ADJUDICATION_SOLVED_UUID = "FILTER_ADJUDICATION_SOLVED_UUID",
	FILTER_ADJUDICATION_SOLVED_OPERATION_UUID = "FILTER_ADJUDICATION_SOLVED_OPERATION_UUID",
	FILTER_ADJUDICATION_SOLVED_ADJUDICATION_DATE = "FILTER_ADJUDICATION_SOLVED_ADJUDICATION_DATE",
	FILTER_ADJUDICATION_SOLVED_DECISION_DATE = "FILTER_ADJUDICATION_SOLVED_DECISION_DATE",
	FILTER_ADJUDICATION_SOLVED_ISSUES = "FILTER_ADJUDICATION_SOLVED_ISSUES",
	FILTER_ADJUDICATION_SOLVED_FINAL_DECISION = "FILTER_ADJUDICATION_SOLVED_FINAL_DECISION",
}

export interface IAdjudicationSolvedFilter {
    fieldToOrderBy?: AdjudicationSolvedFieldOrderBy,
    fieldsOrder?: FieldsOrder,

    uuid?: string,
    operationUuid?: string,
    dateAdjudicationLowerBound?: number,
    dateAdjudicationUpperBound?: number,
    dateDecisionLowerBound?: number,
    dateDecisionUpperBound?: number,
    issues?: AdjudicationSolvedIssues[]
    decision?: AdjudicationSolvedFinalDecision[],
}

export enum AdjudicationIssues {
    ISSUE_LIVENESS = "ISSUE_LIVENESS",
    ISSUE_AGE = "ISSUE_AGE",
}

export enum AdjudicationDecision {
    DECISION_ACCEPTED = "DECISION_ACCEPTED",
    DECISION_REJECTED_AGE = "DECISION_REJECTED_AGE",
    DECISION_REJECTED_LIVENESS = "DECISION_REJECTED_LIVENESS",
};

export enum AdjudicatorTypeOfAttack {
    ATTACK_NONE = "ATTACK_NONE",
    ATTACK_PICTURE = "ATTACK_PICTURE",
    ATTACK_PAPER_MASK = "ATTACK_PAPER_MASK",
    ATTACK_SILICONE_MASK = "ATTACK_SILICONE_MASK",
    ATTACK_SCREEN_PHONE = "ATTACK_SCREEN_PHONE",
    ATTACK_SCREEN_PC = "ATTACK_SCREEN_PC",
    ATTACK_VIDEO = "ATTACK_VIDEO",
    ATTACK_MASK = "ATTACK_MASK",
};
